/* @flow */

import React from 'react';
import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';
import { spinnable } from 'components/UIKit/decorators';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';


export type BiospecimenDownloadContainerType = {
  setIsSpinning: () => {},
  isSpinning: boolean,
  downloadBiospecimen: () => {},
  downloadBiospecimenByType: () => {},
  downloadSingleBiospecimen: () => {},
  downloadAll: ?boolean,
  type: ?string,
  marginOffset: any,
  children: any,
  customDataTestID?: string
}

function BiospecimenDownloadContainer({
  setIsSpinning,
  isSpinning,
  downloadBiospecimen,
  downloadBiospecimenByType,
  downloadSingleBiospecimen,
  downloadAll,
  type,
  marginOffset,
  children,
  customDataTestID,
}: BiospecimenDownloadContainerType): React.Element {
  return (
    <DownloadDropdown
      marginOffset={marginOffset}
      setIsSpinning={setIsSpinning}
      download={
        async format => {
          if (type) {
            await downloadBiospecimenByType(type, format);
          } else if (downloadAll) {
            await downloadBiospecimen(format);
          } else await downloadSingleBiospecimen(format);
        }
      }
      formats={['tsv', 'json']}
      >
      <Button
        data-testid={customDataTestID}
        disabled={isSpinning}
        PrefixComponent={isSpinning
          ? <Spinner style={{ height: '1rem', width: '1rem', marginRight: '2px' }} />
          : <DownloadIcon />}
        >
        { children || 'Biospecimen' }
      </Button>
    </DownloadDropdown>
  );
}

export default canDownloadEntities(spinnable(BiospecimenDownloadContainer));
